import { ArrowUpTrayIcon } from "@/icons/outline";
import React, { useState, useEffect } from "react";

import { connect } from 'react-redux';

import { Actions as LEAVEADJUSTMENTACTIONS } from '../../../../store/actions/leaveAdjustmentActions';

const ImportLeaveAdjustment = ({
    showImportModal,
    hideButton
}) => {
    if (hideButton) return null
    return (
        <div
            className="btn btn-default pull-right"
            onClick={showImportModal}
        >
            <ArrowUpTrayIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
            <div style={{ float: "left" }}>Import Leave Adjustments</div>
        </div>
    )
}

const mapStateToProps = (state) => {
    const timeAttendanceList = Object.values(state.integration?.timeAttendance || {})?.reduce((prev, curr) => {
        prev.push(curr.name)
        return prev
    }, [])
    return {
        hideButton: false //timeAttendanceList?.length > 0
    }
}
const mapDispatchToProps = dispatch => ({
    showImportModal: () => dispatch(LEAVEADJUSTMENTACTIONS.showImportModal(true)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImportLeaveAdjustment)